// Componente para exibir seção de pragas
import React from "react";
import caterpillar from "../../../images/caterpillar.png";
import moth from "../../../images/moth.png";
import psilide from "../../../images/psilide.png";
import beetle from "../../../images/beetle.png";
import style from "../body-dashboard.module.css";

/**
 * Componente PlaguesSection - Seção de pragas com maior chance de infestação
 */
const PlaguesSection = ({ plagues }) => {
  const getPlagueImage = (plagueName) => {
    const caterpillarPlagues = ["Lagarta Parda", "Lagarta Verde", "Lagarta Cachorrinho", "Lagarta Marrom"];
    const mothPlagues = ["Glena", "Sarsina", "Dyrphia", "Nistalea", "Hylesia", "Sabulodes"];
    const beetlePlagues = ["Percevejo Bronzeado", "Besouro Amarelo", "Besouro Azul"];

    if (caterpillarPlagues.includes(plagueName)) {
      return caterpillar;
    } else if (mothPlagues.includes(plagueName)) {
      return moth;
    } else if (beetlePlagues.includes(plagueName)) {
      return beetle;
    } else {
      return psilide;
    }
  };

  const getBarColor = (percentual) => {
    if (percentual <= 30.0) return "green";
    if (percentual <= 50.0 && percentual >= 30.1) return "#FEC601";
    return "red";
  };

  return (
    <div className={style["bugs-qtd"]}>
      <div className={style["text-info"]}>
        Pragas com maior chance de infestação
      </div>

      <div>
        {plagues.map((plague, index) =>
          !isNaN(plague.percentual) && plague.percentual !== 0 ? (
            <div key={index} className={style["plague-informations"]}>
              <div>
                <img
                  className={style["Images-plagues"]}
                  src={getPlagueImage(plague.plague)}
                  alt={plague.plague}
                  style={plague.plague === "Psilideo de Concha" ? { marginBottom: "15px" } : {}}
                />
              </div>

              <div className={style["bar"]}>
                <div className={style["text-plague"]}>
                  <strong>{plague.plague}</strong>
                </div>

                <div className={style["barra"]}>
                  <div
                    className={style["barra-color"]}
                    style={{
                      width: `${plague.percentual}%`,
                      backgroundColor: getBarColor(plague.percentual),
                    }}
                  >
                    {plague.percentual.toFixed(1)} %
                  </div>
                </div>
              </div>
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default PlaguesSection;

